export enum UploadCategoryEnum {
  APPLICATION_LOGO = 'APP_LOGO',
  LEGEND = 'LEGEND',
  IMAGE = 'IMAGE',
  SSO_IMAGE = 'SSO_IMAGE',
  LAYER_ATTACHED_FILE = 'LAYER_ATTACHED_FILE',
  UNRESTRICTED = 'UNRESTRICTED',
  HEADER_LOGO = 'HEADER_LOGO',
  DRAWING_STYLE = 'DRAWING_STYLE',
  DRAWING_STYLE_IMAGE = 'DRAWING_STYLE_IMAGE',
}
